module.exports = __webpack_public_path__ + "static/media/logo-braintree.2d729b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-braintree.png
// module id = 1298
// module chunks = 17